(function () {
  'use strict';

  function initGrid(root) {
    root.querySelectorAll('[data-collection-grid]').forEach(function (grid) {
      grid.querySelectorAll('[data-dropdown-trigger]').forEach(function (trigger) {
        if (trigger._cgInit) return;
        trigger._cgInit = true;

        const wrap = trigger.closest('.quick-buy-dropdown');
        const menu = wrap && wrap.querySelector('[data-dropdown-menu]');
        if (!menu) return;

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          const isOpen = wrap.classList.contains('open');

          // Close all dropdowns in this grid first
          grid.querySelectorAll('.quick-buy-dropdown').forEach(function (d) {
            d.classList.remove('open');
            d.querySelector('[data-dropdown-menu]').style.display = 'none';
          });

          if (!isOpen) {
            menu.style.display = 'block';
            wrap.classList.add('open');
          }
        });
      });
    });
  }

  // Close when clicking outside any collection grid dropdown
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-collection-grid] .quick-buy-dropdown')) {
      document.querySelectorAll('[data-collection-grid] .quick-buy-dropdown').forEach(function (d) {
        d.classList.remove('open');
        var m = d.querySelector('[data-dropdown-menu]');
        if (m) m.style.display = 'none';
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initGrid(document); });
  } else {
    initGrid(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initGrid(e.target); });
})();
